var _path, _path2, _ellipse, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupervisor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.315 12.63C14.8027 12.63 17.63 9.80268 17.63 6.315C17.63 2.82732 14.8027 0 11.315 0C7.82732 0 5 2.82732 5 6.315C5 9.80268 7.82732 12.63 11.315 12.63Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.055 29.63C17.1605 29.63 22.11 26.8027 22.11 23.315C22.11 19.8273 17.1605 17 11.055 17C4.94949 17 0 19.8273 0 23.315C0 26.8027 4.94949 29.63 11.055 29.63Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 23,
    rx: 15,
    ry: 10,
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4024 26.2957C15.4675 25.1915 15 24.6394 15 23C15 21.3606 15.4675 20.8085 16.4024 19.7043C18.2692 17.4996 21.3999 15 26 15C30.6001 15 33.7308 17.4996 35.5976 19.7043C36.5325 20.8085 37 21.3606 37 23C37 24.6394 36.5325 25.1915 35.5976 26.2957C33.7308 28.5004 30.6001 31 26 31C21.3999 31 18.2692 28.5004 16.4024 26.2957Z",
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23C29 24.6569 27.6569 26 26 26C24.3431 26 23 24.6569 23 23C23 21.3431 24.3431 20 26 20C27.6569 20 29 21.3431 29 23Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisor);
export default __webpack_public_path__ + "static/media/supervisor.e3a9db3712671d3489fed3e48a8601dd.svg";
export { ForwardRef as ReactComponent };